import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import _ from "lodash";

// Find all campaigns for an article with O(1) performance
export const selectCampaignVoucherdefsMap = createSelector(
  [(state: RootState) => state.menuData.campaign_voucherdefs],
  (campaign_voucherdefs) => {
    return _.chain(campaign_voucherdefs)
      .groupBy("campaign_id")
      .mapValues((pivots) => pivots.map((pivot) => pivot.voucherdef_id))
      .value();
  }
);
